module.exports = __webpack_public_path__ + "media/images/category_icons/booklet-556abbe104f5b3ef684451713036168b.svg";